import React, { useEffect, useState } from "react";
import { InstuctorTable } from "./Data Tables/InstuctorTable";
import { UAspotTable } from "./Data Tables/UAspotTable";
import { UAspotTable_2 } from "./Data Tables/UAspotTable_2";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import { UAspotBarChart } from "./Data Tables/UAspotBarChart";
import { ReportHeader } from "./ReportHeader";
import { SupplementaryTable } from "./Data Tables/SupplementaryTable";
import { CommentsTable } from "./Data Tables/CommentsTable";
import { UAspotRadarChart } from "./Data Tables/UAradarChart";
// import { UAtrendChart } from "./Data Tables/UAtrendChart";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { SearchablePDF } from "../Report Download/SearchablePDF";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import { getSpotReportDataSingle } from "../../../components/Api/Getters";
import isAuthenticated from "../../../components/Utils/isAuthenticated";

// This function creates a data object with specified properties.
function createData(category, question, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
	return { category, question, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
}

// This function creates a data object with specified properties for custom questions.
function createCustomeData(category, question, rsp1, rsp2, rsp3, rsp4, rsp5, scale) {
	return { category, question, rsp1, rsp2, rsp3, rsp4, rsp5, scale };
}

// This function creates a summary data object with specified properties, excluding the question.
function createSummaryData(category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor) {
	return { category, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor };
}

// This function summarizes the provided data by category, aggregating response values.
function summarizeData(data) {
	const summary = data.reduce((acc, row) => {
		if (row.category in acc) {
			// Aggregate response values for existing category.
			acc[row.category][0] += Number(row.rsp1);
			acc[row.category][1] += Number(row.rsp2);
			acc[row.category][2] += Number(row.rsp3);
			acc[row.category][3] += Number(row.rsp4);
			acc[row.category][4] += Number(row.rsp5);
		} else {
			// Create a new category entry with aggregated response values.
			acc[row.category] = [
				Number(row.rsp1),
				Number(row.rsp2),
				Number(row.rsp3),
				Number(row.rsp4),
				Number(row.rsp5),
				row.backgroundColor,
			];
		}
		return acc;
	}, {});

	// Convert the summarized data into an array of summary objects.
	const output = Object.keys(summary).map((key) => {
		const [rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor] = summary[key];
		return createSummaryData(key, rsp1, rsp2, rsp3, rsp4, rsp5, backgroundColor);
	});

	return output;
}

// // Define color codes for categories.
// const colours = {
//     'Design':'#b6e3e9','Utility of course resources':'#a6e3b7','Graded Work':'#fce49b',
//     'Course delivery' : '#f7b4af','Instructional approach' : '#8cb4f9','Class Climate' : '#fac498'
//  }

// Define color codes for categories.
const colours = {
	Design: "rgba(235, 235, 235, 1)",
	"Graded Work": "rgba(235, 235, 235, 1)",
	"Instructional Approach": "rgba(235, 235, 235, 1)",
};

const reportDataCache = new Map();

function getCachedSpotReportData(token, classRequisition) {
	const cacheKey = `${token}:${classRequisition}`;
	if (!reportDataCache.has(cacheKey)) {
		const request = getSpotReportDataSingle(token, classRequisition).finally(() => {
			reportDataCache.delete(cacheKey);
		});
		reportDataCache.set(cacheKey, request);
	}
	return reportDataCache.get(cacheKey);
}

// This component represents a tabbed interface for displaying data.
function TabInterface({ classRequisition }) {
	const [spotData, setSpotData] = useState([]);
	const [customSpotData, setCustomSpotData] = useState([]);
	const [spotComments, setSpotComments] = useState({});
	const [value, setValue] = useState("1");
	const [courseINFO, setCourseINFO] = useState([]);
	const [radarData, setRadarData] = useState(null);
	const [additionalData, setAdditionalData] = useState([]);
	const [comparisonData, setComparisonData] = useState([]);
	const [comparisonLoading, setComparisonLoading] = useState(true);
	const [tooManyComparisons, setTooManyComparisons] = useState(false);
	const [domainStatWindow, setDomainStatWindow] = useState(false);
	const [domainCategory, setDomainCategory] = useState(null);
	const [domainComments, setDomainComments] = useState(null);
	const [domainQuestions, setDomainQuestions] = useState([]);
	const [radarChartMin, setRadarChartMin] = useState(1);
	const [radarChartScale, setRadarChartScale] = useState(1);
	const [infoWindow, setInfoWindow] = useState(false);
	const [trendData, setTrendData] = useState(null);
	const [termList, setTermList] = useState([]);
	const [trendDomain, setTrendDomain] = useState(null);
	const [trendComparison, setTrendComparison] = useState(null);
	const [tooManyTrendPoints, setTooManyTrendPoints] = useState(false);
	const auth = isAuthenticated();
	const token = auth.token;

	const [openWindow, setOpenWindow] = useState(false); // Control the visibility of a dialog window
	const [checked, setChecked] = useState([true, true, true, true, true, false]);
	const [pdfLoading, setPdfLoading] = useState(false);

	const [loadingWheel, setLoadingWheel] = useState(true);

	const handleCheck0 = (event) => {
		setChecked([event.target.checked, checked[1], checked[2], checked[3], checked[4], checked[5]]);
	};

	const handleCheck1 = (event) => {
		setChecked([checked[0], event.target.checked, checked[2], checked[3], checked[4], checked[5]]);
	};

	const handleCheck2 = (event) => {
		setChecked([checked[0], checked[1], event.target.checked, checked[3], checked[4], checked[5]]);
	};

	const handleCheck3 = (event) => {
		setChecked([checked[0], checked[1], checked[2], event.target.checked, checked[4], checked[5]]);
	};

	const handleCheck4 = (event) => {
		setChecked([checked[0], checked[1], checked[2], checked[3], event.target.checked, checked[5]]);
	};

	const handleCheck5 = (event) => {
		setChecked([checked[0], checked[1], checked[2], checked[3], checked[4], event.target.checked]);
	};

	const handleClickOpen = () => {
		setOpenWindow(true);
	};

	const handleClose = () => {
		setOpenWindow(false);
	};

	// Handle tab change.
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	useEffect(() => {
		let cancelled = false;

		async function reportData() {
			setLoadingWheel(true);
			try {
				const apiData = await getCachedSpotReportData(token, classRequisition);

				let req_info = [
					apiData[0].req_info.ctitle,
					apiData[0].req_info.inst,
					apiData[0].req_info.term,
					apiData[0].req_info.faculty,
					apiData[0].req_info.dept,
					apiData[0].req_info.reqnum,
					apiData[0].req_info.clsnum,
					apiData[0].req_info.csize,
					apiData[0].req_info.qtally,
					apiData[0].req_info.empid,
				];

				let question_data = [];
				if (apiData[0].req_info.questions.length) {
					let unformated_data = apiData[0].req_info.questions.split("|~^~|");
					// Parse and format question data.
					for (let i = 0; i < unformated_data.length; i++) {
						let entry = unformated_data[i].slice(1, -1).split("|~|");
						entry = createData(
							entry[0].trim(),
							entry[2].trim(),
							entry[3].trim(),
							entry[4].trim(),
							entry[5].trim(),
							entry[6].trim(),
							entry[7].trim(),
							colours[entry[0].trim()],
						);
						question_data.push(entry);
					}
				}

				let custom_questions = [];
				if (apiData[0].customSpotData.questions.length) {
					let unformated_data = apiData[0].customSpotData.questions.split("|~^~|");

					// Parse and format question data.
					for (let i = 0; i < unformated_data.length; i++) {
						let entry = unformated_data[i].slice(1, -1).split("|~|");
						entry = createCustomeData(
							entry[0].trim(),
							entry[2].trim(),
							entry[3].trim(),
							entry[4].trim(),
							entry[5].trim(),
							entry[6].trim(),
							entry[7].trim(),
							entry[8].trim().split(";"),
						);
						custom_questions.push(entry);
					}
				}

				let commentData = apiData[0].comments;
				if (cancelled) {
					return;
				}

				setSpotData(question_data);
				setCourseINFO(req_info);
				setCustomSpotData(custom_questions);
				setSpotComments(commentData);
				setDomainComments({
					ctitle: commentData.ctitle,
					csize: commentData.csize,
					qtally: commentData.qtally,
					results: {},
				});
				setLoadingWheel(false);
			} catch (error) {
				console.error("Unable to load SPOT report data", error);
				if (!cancelled) {
					setLoadingWheel(false);
				}
			}
		}

		reportData();

		return () => {
			cancelled = true;
		};
	}, [classRequisition, token]);

	async function downloadReport() {
		setPdfLoading(true);
		let filename = courseINFO[2].concat(" - ", courseINFO[0], " - ", courseINFO[1], ".pdf");
		await SearchablePDF([classRequisition], checked, filename, radarData, trendComparison);
		setPdfLoading(false);
	}

	return (
		<div>
			{ReportHeader(courseINFO)}

			{loadingWheel ? (
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					height="50vh" // Set height to 100% of the viewport height
				>
					<CircularProgress />
				</Box>
			) : (
				<Box
					sx={{
						minWidth: "1000px",
						maxWidth: "100%",
						display: "flex",
						flexDirection: "column",
						paddingLeft: "50px",
						paddingRight: "50px" /*border: '3px solid blue'*/,
					}}
				>
					{spotData.length > 0 &&
						sessionStorage.getItem("access").includes("STD") &&
						Number(sessionStorage.getItem("id")) !== courseINFO[9] && (
							<TabContext value={value}>
								<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
									<Tabs onChange={handleChange} value={value} centered={false}>
										<Tab label="Standard SPOT Questions" value="1" />
										<Tab label="Summary Data" value="2" />
									</Tabs>
								</Box>
								<TabPanel value="1">{InstuctorTable(spotData)}</TabPanel>
								<TabPanel value="2">{UAspotTable(spotData)}</TabPanel>
							</TabContext>
						)}

					{customSpotData.length < 1 &&
						spotData.length > 0 &&
						((!sessionStorage.getItem("access").includes("STD") &&
							(sessionStorage.getItem("access").includes("INST") ||
								sessionStorage.getItem("access").includes("DDC") ||
								sessionStorage.getItem("access").includes("ADMIN"))) ||
							Number(sessionStorage.getItem("id")) === courseINFO[9]) && (
							<TabContext value={value}>
								<Box
									sx={{
										borderBottom: 1,
										borderColor: "divider",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Tabs onChange={handleChange} value={value} centered={false}>
										<Tab label="Standard SPOT Questions" value="1" />
										<Tab label="Summary Data" value="2" />

										{Number(sessionStorage.id) === Number(courseINFO[9]) && (
											<Tab label="Radar Tool" value="3" />
										)}

										{/* {Number(sessionStorage.id) === Number(courseINFO[9]) && (
										<Tab
											label="Trend Analysis"
											value="4"
										/>)} */}

										<Tab label="Comments" value="5" />
									</Tabs>
									<Button
										variant="contained"
										sx={{ height: "35px" }}
										endIcon={<DownloadIcon />}
										onClick={handleClickOpen}
									>
										PDF Download
									</Button>
									<Dialog open={openWindow} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
										<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
											SPOT REPORT
										</DialogTitle>
										{pdfLoading ? (
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													paddingBottom: "20px",
												}}
											>
												<CircularProgress size={80} />
											</Box>
										) : (
											<div>
												<DialogContent>
													<Box
														sx={{
															display: "flex",
															flexDirection: "column",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<Typography>
															Select which elements you would like included in the PDF report:
														</Typography>
														<br></br>
														<FormGroup>
															<FormControlLabel
																control={<Checkbox checked={checked[0]} onChange={handleCheck0} />}
																label="Standard SPOT Questions"
															/>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck1}
																	/>
																}
																label="Supplementary Questions"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[2]} onChange={handleCheck2} />}
																label="Summary Data"
															/>
															<FormControlLabel
																control={<Checkbox checked={checked[4]} onChange={handleCheck4} />}
																label="Radar Tool"
															/>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={checked[5]}
																		onChange={handleCheck5}
																	/>
																}
																label="Trend Analysis"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[3]} onChange={handleCheck3} />}
																label="Comments"
															/>
														</FormGroup>
													</Box>
												</DialogContent>

												<DialogActions sx={{ justifyContent: "center" }}>
													<Button onClick={handleClose}>Close</Button>
													<Button onClick={downloadReport}>Generate</Button>
												</DialogActions>
											</div>
										)}
									</Dialog>
								</Box>
								<TabPanel value="1">{InstuctorTable(spotData)}</TabPanel>
								<TabPanel value="2">
									{/* {Number(sessionStorage.id) === Number(courseINFO[9]) ? (
										<UAspotTable_2
											data ={spotData}
											domainStatWindow={domainStatWindow}
											setDomainStatWindow={setDomainStatWindow}
											domainCategory={domainCategory}
											setDomainCategory={setDomainCategory}
											domainComments={domainComments}
											setDomainComments={setDomainComments}
											domainQuestions={domainQuestions}
											setDomainQuestions={setDomainQuestions}
											spotComments = {spotComments}
										/>
									):(
										UAspotTable(spotData)
									)} */}
									<Box sx={{ width: "99%"}}>
										{UAspotTable(spotData)}
										<br/>
										{UAspotBarChart(courseINFO, summarizeData(spotData))}
									</Box>
								</TabPanel>
								<TabPanel value="3">
									<UAspotRadarChart
										courseINFO={courseINFO}
										spotData={summarizeData(spotData)}
										radarData={radarData}
										setRadarData={setRadarData}
										comparisonData={comparisonData}
										setComparisonData={setComparisonData}
										comparisonLoading={comparisonLoading}
										setComparisonLoading={setComparisonLoading}
										additionalData={additionalData}
										setAdditionalData={setAdditionalData}
										tooManyComparisons={tooManyComparisons}
										setTooManyComparisons={setTooManyComparisons}
										radarChartMin={radarChartMin}
										setRadarChartMin={setRadarChartMin}
										radarChartScale={radarChartScale}
										setRadarChartScale={setRadarChartScale}
										infoWindow={infoWindow}
										setInfoWindow={setInfoWindow}
									/>
								</TabPanel>
								{/* <TabPanel value="4">
									<UAtrendChart
										courseINFO={courseINFO}
										spotData={summarizeData(spotData)}
										comparisonData={comparisonData}
										setComparisonData={setComparisonData}
										comparisonLoading={comparisonLoading}
										setComparisonLoading={setComparisonLoading}
										trendData={trendData}
										setTrendData={setTrendData}
										termList={termList}
										setTermList={setTermList}
										trendDomain={trendDomain}
										setTrendDomain={setTrendDomain}
										trendComparison={trendComparison}
										setTrendComparison={setTrendComparison}
										tooManyTrendPoints={tooManyTrendPoints}
										setTooManyTrendPoints={setTooManyTrendPoints}
										infoWindow={infoWindow}
										setInfoWindow={setInfoWindow}
									/>
								</TabPanel> */}
								<TabPanel value="5">{CommentsTable(spotComments)}</TabPanel>
							</TabContext>
						)}

					{customSpotData.length > 0 &&
						spotData.length > 0 &&
						((!sessionStorage.getItem("access").includes("STD") &&
							(sessionStorage.getItem("access").includes("INST") ||
								sessionStorage.getItem("access").includes("DDC") ||
								sessionStorage.getItem("access").includes("ADMIN"))) ||
							Number(sessionStorage.getItem("id")) === courseINFO[9]) && (
							<TabContext value={value}>
								<Box
									sx={{
										borderBottom: 1,
										borderColor: "divider",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Tabs onChange={handleChange} value={value} centered={false}>
										<Tab label="Standard SPOT Questions" value="1" />
										<Tab label="Supplementary Questions" value="2" />
										<Tab label="Summary Data" value="3" />

										{Number(sessionStorage.id) === Number(courseINFO[9]) && (
											<Tab label="Radar Tool" value="4" />
										)}

										{/* {Number(sessionStorage.id) === Number(courseINFO[9]) && (
										<Tab
											label="Trend Analysis"
											value="5"
										/>
										)} */}

										<Tab label="Comments" value="6" />
									</Tabs>
									<Button
										variant="contained"
										sx={{ height: "35px" }}
										endIcon={<DownloadIcon />}
										onClick={handleClickOpen}
									>
										PDF Download
									</Button>
									<Dialog open={openWindow} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
										<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
											SPOT REPORT
										</DialogTitle>
										{pdfLoading ? (
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													paddingBottom: "20px",
												}}
											>
												<CircularProgress size={80} />
											</Box>
										) : (
											<div>
												<DialogContent>
													<Box
														sx={{
															display: "flex",
															flexDirection: "column",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<Typography>
															Select which elements you would like included in the PDF report:
														</Typography>
														<br></br>
														<FormGroup>
															<FormControlLabel
																control={<Checkbox checked={checked[0]} onChange={handleCheck0} />}
																label="Standard SPOT Questions"
															/>
															<FormControlLabel
																control={<Checkbox checked={checked[1]} onChange={handleCheck1} />}
																label="Supplementary Questions"
															/>
															<FormControlLabel
																control={<Checkbox checked={checked[2]} onChange={handleCheck2} />}
																label="Summary Data"
															/>
															<FormControlLabel
																control={<Checkbox checked={checked[4]} onChange={handleCheck4} />}
																label="Radar Tool"
															/>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={checked[5]}
																		onChange={handleCheck5}
																	/>
																}
																label="Trend Analysis"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[3]} onChange={handleCheck3} />}
																label="Comments"
															/>
														</FormGroup>
													</Box>
												</DialogContent>

												<DialogActions sx={{ justifyContent: "center" }}>
													<Button onClick={handleClose}>Close</Button>
													<Button onClick={downloadReport}>Generate</Button>
												</DialogActions>
											</div>
										)}
									</Dialog>
								</Box>
								<TabPanel value="1">{InstuctorTable(spotData)}</TabPanel>
								<TabPanel value="2">{SupplementaryTable(customSpotData)}</TabPanel>
								<TabPanel value="3">
									{/* {Number(sessionStorage.id) === Number(courseINFO[9]) ? (
										<UAspotTable_2
											data ={spotData}
											domainStatWindow={domainStatWindow}
											setDomainStatWindow={setDomainStatWindow}
											domainCategory={domainCategory}
											setDomainCategory={setDomainCategory}
											domainComments={domainComments}
											setDomainComments={setDomainComments}
											domainQuestions={domainQuestions}
											setDomainQuestions={setDomainQuestions}
											spotComments = {spotComments}
										/>
									):(
										UAspotTable(spotData)
									)} */}
									
									<Box sx={{ width: "99%"}}>
										{UAspotTable(spotData)}
										<br/>
										{UAspotBarChart(courseINFO, summarizeData(spotData))}
									</Box>
								
								</TabPanel>
								<TabPanel value="4">
									<UAspotRadarChart
										courseINFO={courseINFO}
										spotData={summarizeData(spotData)}
										radarData={radarData}
										setRadarData={setRadarData}
										comparisonData={comparisonData}
										setComparisonData={setComparisonData}
										comparisonLoading={comparisonLoading}
										setComparisonLoading={setComparisonLoading}
										additionalData={additionalData}
										setAdditionalData={setAdditionalData}
										tooManyComparisons={tooManyComparisons}
										setTooManyComparisons={setTooManyComparisons}
										radarChartMin={radarChartMin}
										setRadarChartMin={setRadarChartMin}
										radarChartScale={radarChartScale}
										setRadarChartScale={setRadarChartScale}
										infoWindow={infoWindow}
										setInfoWindow={setInfoWindow}
									/>
								</TabPanel>
								{/* <TabPanel value="5">
									<UAtrendChart
										courseINFO={courseINFO}
										spotData={summarizeData(spotData)}
										comparisonData={comparisonData}
										setComparisonData={setComparisonData}
										comparisonLoading={comparisonLoading}
										setComparisonLoading={setComparisonLoading}
										trendData={trendData}
										setTrendData={setTrendData}
										termList={termList}
										setTermList={setTermList}
										trendDomain={trendDomain}
										setTrendDomain={setTrendDomain}
										trendComparison={trendComparison}
										setTrendComparison={setTrendComparison}
										tooManyTrendPoints={tooManyTrendPoints}
										setTooManyTrendPoints={setTooManyTrendPoints}
										infoWindow={infoWindow}
										setInfoWindow={setInfoWindow}
									/>
								</TabPanel> */}
								<TabPanel value="6">{CommentsTable(spotComments)}</TabPanel>
							</TabContext>
						)}

					{customSpotData.length > 0 &&
						spotData.length < 1 &&
						((!sessionStorage.getItem("access").includes("STD") &&
							(sessionStorage.getItem("access").includes("INST") ||
								sessionStorage.getItem("access").includes("DDC") ||
								sessionStorage.getItem("access").includes("ADMIN"))) ||
							Number(sessionStorage.getItem("id")) === courseINFO[9]) && (
							<TabContext value={value}>
								<Box
									sx={{
										borderBottom: 1,
										borderColor: "divider",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Tabs onChange={handleChange} value={value} centered={false}>
										<Tab label="Supplementary Questions" value="1" />
										<Tab label="Comments" value="2" />
									</Tabs>
									<Button
										variant="contained"
										sx={{ height: "35px" }}
										endIcon={<DownloadIcon />}
										onClick={handleClickOpen}
									>
										PDF Download
									</Button>
									<Dialog open={openWindow} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
										<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
											SPOT REPORT
										</DialogTitle>
										{pdfLoading ? (
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													paddingBottom: "20px",
												}}
											>
												<CircularProgress size={80} />
											</Box>
										) : (
											<div>
												<DialogContent>
													<Box
														sx={{
															display: "flex",
															flexDirection: "column",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<Typography>
															Select which elements you would like included in the PDF report:
														</Typography>
														<br></br>
														<FormGroup>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck0}
																	/>
																}
																label="Standard SPOT Questions"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[1]} onChange={handleCheck1} />}
																label="Supplementary Questions"
															/>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck2}
																	/>
																}
																label="Summary Data"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[3]} onChange={handleCheck3} />}
																label="Comments"
															/>
														</FormGroup>
													</Box>
												</DialogContent>

												<DialogActions sx={{ justifyContent: "center" }}>
													<Button onClick={handleClose}>Close</Button>
													<Button onClick={downloadReport}>Generate</Button>
												</DialogActions>
											</div>
										)}
									</Dialog>
								</Box>
								<TabPanel value="1">{SupplementaryTable(customSpotData)}</TabPanel>
								<TabPanel value="2">{CommentsTable(spotComments)}</TabPanel>
							</TabContext>
						)}

					{customSpotData.length < 1 &&
						spotData.length < 1 &&
						((!sessionStorage.getItem("access").includes("STD") &&
							(sessionStorage.getItem("access").includes("INST") ||
								sessionStorage.getItem("access").includes("DDC") ||
								sessionStorage.getItem("access").includes("ADMIN"))) ||
							Number(sessionStorage.getItem("id")) === courseINFO[9]) && (
							<TabContext value={value}>
								<Box
									sx={{
										borderBottom: 1,
										borderColor: "divider",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Tabs onChange={handleChange} value={value} centered={false}>
										<Tab label="Comments" value="1" />
									</Tabs>
									<Button
										variant="contained"
										sx={{ height: "35px" }}
										endIcon={<DownloadIcon />}
										onClick={handleClickOpen}
									>
										PDF Download
									</Button>
									<Dialog open={openWindow} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
										<DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
											SPOT REPORT
										</DialogTitle>
										{pdfLoading ? (
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													paddingBottom: "20px",
												}}
											>
												<CircularProgress size={80} />
											</Box>
										) : (
											<div>
												<DialogContent>
													<Box
														sx={{
															display: "flex",
															flexDirection: "column",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<Typography>
															Select which elements you would like included in the PDF report:
														</Typography>
														<br></br>
														<FormGroup>
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck0}
																	/>
																}
																label="Standard SPOT Questions"
															/> */}
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck1}
																	/>
																}
																label="Supplementary Questions"
															/> */}
															{/* <FormControlLabel
																control={
																	<Checkbox
																		checked={false}
																		onChange={handleCheck2}
																	/>
																}
																label="Summary Data"
															/> */}
															<FormControlLabel
																control={<Checkbox checked={checked[3]} onChange={handleCheck3} />}
																label="Comments"
															/>
														</FormGroup>
													</Box>
												</DialogContent>

												<DialogActions sx={{ justifyContent: "center" }}>
													<Button onClick={handleClose}>Close</Button>
													<Button onClick={downloadReport}>Generate</Button>
												</DialogActions>
											</div>
										)}
									</Dialog>
								</Box>
								<TabPanel value="1">{CommentsTable(spotComments)}</TabPanel>
							</TabContext>
						)}
				</Box>
			)}
		</div>
	);
}

export { TabInterface };
